import { render, staticRenderFns } from "./InsertOrderModal.vue?vue&type=template&id=569f54b9&scoped=true&"
import script from "./InsertOrderModal.vue?vue&type=script&lang=js&"
export * from "./InsertOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./InsertOrderModal.vue?vue&type=style&index=0&id=569f54b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f54b9",
  null
  
)

export default component.exports